import { createContext, useContext, useState, useEffect } from 'react';

// Translation strings
const translations = {
    tr: {
        // Navigation
        nav: {
            home: 'Ana Sayfa',
            about: 'Hakkında',
            committees: 'Komiteler',
            venue: 'Mekan',
            contact: 'İletişim',
            applyNow: 'Başvur'
        },
        // Home Page
        home: {
            heroTitle1: 'Girne Model',
            heroTitle2: 'Birleşmiş Milletler',
            tagline: "Yarının Diplomatlarını Bugün Şekillendiriyoruz",
            learnMore: 'Daha Fazla',
            countdown: {
                days: 'Gün',
                hours: 'Saat',
                minutes: 'Dakika',
                seconds: 'Saniye'
            },
            features: {
                title: 'Her Detayda Mükemmellik',
                subtitle: 'Neden Bizi Seçmelisiniz',
                description: 'Girne MUN 2026, gelecek nesil dünya liderlerini ilham vermek, eğitmek ve güçlendirmek için tasarlanmış benzersiz bir konferans deneyimi sunuyor.',
                expertSecretariat: 'Uzman Sekretarya',
                expertSecretariatDesc: 'Profesyonel rehberlik ile olağanüstü bir MUN deneyimi sunmaya adanmış deneyimli ekip.',
                academicExcellence: 'Akademik Mükemmellik',
                academicExcellenceDesc: 'Delegeleri eleştirel ve yaratıcı düşünmeye zorlayan yüksek kaliteli tartışmalar.',
                globalPerspective: 'Küresel Perspektif',
                globalPerspectiveDesc: 'Uluslararası sorunları keşfedin ve dünya meselelerine dair derin bir anlayış geliştirin.',
                educationalGrowth: 'Eğitimsel Gelişim',
                educationalGrowthDesc: 'Topluluk önünde konuşma, müzakere, araştırma ve liderlik becerilerini geliştirin.'
            },
            stats: {
                committees: 'Komite',
                expectedDelegates: 'Beklenen Delege',
                daysOfConference: 'Konferans Günü',
                schoolsInvited: 'Davetli Okul'
            },
            cta: {
                title: 'İz Bırakmaya Hazır mısınız?',
                description: 'Türkiye genelinden yüzlerce delegeye katılın ve unutulmaz bir diplomasi, tartışma ve keşif deneyimi yaşayın. Başvurular açıldı.',
                viewCommittees: 'Komiteleri Gör',
                applyNow: 'Hemen Başvur',
                applicationNote: 'Başvurular yakında kapanıyor — Girne MUN 2026\'daki yerinizi garantileyin'
            }
        },
        // About Page
        about: {
            subtitle: 'Konferans Hakkında',
            title: 'Girne Model Birleşmiş Milletler',
            description: 'Türkiye\'deki lise öğrencileri arasında diplomasi, liderlik ve küresel farkındalık geliştiren birinci sınıf bir akademik simülasyon.',
            whatIs: 'Girne MUN Nedir?',
            whatIsDesc1: 'Girne Model Birleşmiş Milletler, Türkiye genelinden lise öğrencilerini bir araya getirerek güncel küresel sorunları tartışan bir Birleşmiş Milletler akademik simülasyonudur. Konferansımız, genç zihinlerin eleştirel düşünme, topluluk önünde konuşma ve diplomatik becerilerini geliştirmeleri için bir platform sunmaktadır.',
            whatIsDesc2: 'Gelecek liderleri yetiştirme vizyonuyla kurulan Girne MUN, bölgenin en saygın Model BM konferanslarından biri haline gelmiştir. Akademik mükemmellik ve profesyonel organizasyona olan bağlılığımız bizi farklı kılarak delegelere otantik ve zenginleştirici bir deneyim sunmaktadır.',
            whatIsDesc3: '2026 edisyonu, uluslararası güvenlikten tarihsel krizlere kadar uzanan konuları kapsayan 10 farklı komite ile şimdiye kadarki en iddialı konferansımız olmayı vaat ediyor.',
            whatSetsUsApart: 'Bizi Farklı Kılan',
            features: {
                trainedSecretariat: 'Profesyonel eğitimli sekretarya ekibi',
                experiencedChairs: 'Deneyimli başkanlar ve mentorlar',
                qualityGuides: 'Yüksek kaliteli çalışma rehberleri ve kaynaklar',
                delegateTraining: 'Yapılandırılmış delege eğitim oturumları',
                networking: 'Akranlarla ağ kurma fırsatları',
                certificate: 'Tüm delegeler için katılım sertifikası'
            },
            coreValues: 'Temel Değerler',
            foundation: 'Temelimiz',
            excellence: 'Mükemmellik',
            excellenceDesc: 'Konferansımızın komite oturumlarından sosyal etkinliklere kadar her alanında en yüksek standartlar için çalışıyoruz.',
            collaboration: 'İşbirliği',
            collaborationDesc: 'Ekip çalışmasının gücüne inanıyor ve delegeleri ortak hedefler doğrultusunda birlikte çalışmaya teşvik ediyoruz.',
            integrity: 'Dürüstlük',
            integrityDesc: 'Etik standartları koruyoruz ve tüm süreçlerimizde dürüst, saygılı söylemi teşvik ediyoruz.',
            leadership: 'Liderlik',
            experiencedSecretariat: 'Deneyimli Sekretarya',
            secretariatDesc1: 'Sekretarya ekibimiz, Türkiye genelinden en deneyimli MUN organizatörleri ve eski delegeleri bir araya getirmektedir. Yıllarca birleşik Model BM deneyimi ile ekibimiz, olağanüstü bir konferans deneyimi yaratmaya adanmıştır.',
            secretariatDesc2: 'Genel Sekreter\'den komite başkanlarımıza kadar ekibimizin her üyesi, uzmanlıkları, özverileri ve Model Birleşmiş Milletler\'e olan tutkuları için özenle seçilmiştir. MUN yolculuğunuzun her adımında delegeleri desteklemeye kararlıyız.',
            daysOfConference: 'Konferans Günü'
        },
        // Committees Page
        committees: {
            subtitle: 'Konferans Komiteleri',
            title: 'Komitelerimiz',
            description: 'Her deneyim seviyesindeki delegeleri zorlamak ve ilham vermek için tasarlanmış çeşitli komite seçeneklerimizi keşfedin.',
            searchPlaceholder: 'Komite ara...',
            committeesAvailable: 'komite mevcut',
            keyTopics: 'Ana Konular',
            noCommitteesFound: 'Komite bulunamadı',
            adjustSearch: 'Arama terimlerinizi ayarlamayı deneyin',
            notSure: 'Hangi Komite?',
            notSureDesc: 'Başvuru yaparken ilk üç komite tercihinizi seçeceksiniz. Ekibimiz sizi ilgi alanlarınıza ve deneyim seviyenize uygun bir komiteye atamak için elinden geleni yapacaktır.',
            beginner: 'Başlangıç: İlk kez delegeler',
            intermediate: 'Orta: 1-3 konferans',
            advanced: 'İleri: 4+ konferans',
            difficulty: {
                Beginner: 'Başlangıç',
                Intermediate: 'Orta',
                Advanced: 'İleri'
            }
        },
        // Venue Page
        venue: {
            subtitle: 'Konferans Mekanı',
            title: 'Girne Koleji Kampüsü',
            aboutVenue: 'Mekan Hakkında',
            aboutVenueDesc1: 'Girne MUN 2026, Adana\'daki prestijli Girne Koleji Kampüsü\'nde düzenlenecektir. Mekanımız, bu kalibrede bir akademik konferansa ev sahipliği yapmak için son teknoloji tesisler sunmaktadır.',
            aboutVenueDesc2: 'Kampüs, verimli komite oturumları ve ağ kurma fırsatlarını kolaylaştırmak için tasarlanmış modern konferans odaları, geniş toplantı salonları ve konforlu ara mekanlara sahiptir.',
            venueAmenities: 'Mekan Olanakları',
            amenities: {
                wifi: 'Yüksek Hızlı WiFi',
                wifiDesc: 'Mekan genelinde güvenilir internet',
                refreshments: 'İkramlar',
                refreshmentsDesc: 'Kahve molaları ve yemek hizmeti',
                parking: 'Otopark',
                parkingDesc: 'Kampüs içi otopark mevcut',
                capacity: 'Kapasite',
                capacityDesc: '300+ delege kapasitesi'
            },
            clickToView: 'Galeriyi görmek için resimlere tıklayın',
            conferenceSchedule: 'Konferans Programı',
            threeDays: 'Üç Gün Mükemmellik',
            schedule: {
                day1: 'Gün 1 - 27 Mart',
                day2: 'Gün 2 - 28 Mart',
                day3: 'Gün 3 - 29 Mart',
                openingCeremony: 'Açılış Töreni',
                committeeSession1: 'Komite Oturumu I',
                welcomeReception: 'Karşılama Resepsiyonu',
                committeeSession2: 'Komite Oturumu II',
                committeeSession3: 'Komite Oturumu III',
                socialEvent: 'Sosyal Etkinlik',
                committeeSession4: 'Komite Oturumu IV',
                closingCeremony: 'Kapanış Töreni',
                awardsDistribution: 'Ödül Töreni'
            },
            gettingThere: 'Ulaşım',
            address: 'Adres',
            byCar: 'Arabayla',
            freeParking: 'Kampüste ücretsiz otopark mevcut',
            mapPlaceholder: 'İnteraktif harita burada görüntülenecek'
        },
        // Apply Page
        apply: {
            subtitle: 'Girne MUN 2026\'ya Katılın',
            title: 'Başvuru Formu',
            description: 'Konferansımıza delege olarak başvurmak için aşağıdaki formu doldurun. Tüm başvurular için veli/vasi onayı gereklidir.',
            section1: '1. Öğrenci Bilgileri',
            firstName: 'Ad',
            lastName: 'Soyad',
            email: 'E-posta Adresi',
            phone: 'Telefon Numarası',
            optional: 'isteğe bağlı',
            dateOfBirth: 'Doğum Tarihi',
            grade: 'Sınıf / Seviye',
            selectGrade: 'Sınıf seçin',
            city: 'Şehir',
            district: 'İlçe',
            schoolName: 'Okul Adı',
            section2: '2. Komite Tercihleri',
            committeeDesc: 'İlk 3 komite tercihinizi sırayla seçin. Her komite sadece bir kez seçilebilir.',
            preference1: '1. Komite Tercihi',
            preference2: '2. Komite Tercihi',
            preference3: '3. Komite Tercihi',
            selectFirst: 'İlk tercihinizi seçin',
            selectSecond: 'İkinci tercihinizi seçin',
            selectThird: 'Üçüncü tercihinizi seçin',
            section3: '3. Veli / Vasi Bilgileri',
            parentName: 'Veli / Vasi Adı Soyadı',
            parentPhone: 'Veli / Vasi Telefon Numarası',
            section4: '4. Sağlık Bilgileri',
            healthConfidential: 'Gizli — Bu bilgiler özeldir ve sadece acil durumlar için konferans organizatörlerine açıktır.',
            chronicIllness: 'Öğrencinin kronik bir hastalığı var mı?',
            yes: 'Evet',
            no: 'Hayır',
            allergies: 'Alerjiler',
            ifAny: 'varsa',
            allergiesPlaceholder: 'Bilinen alerjileri listeleyin (yiyecek, ilaç, çevresel, vb.)',
            emergencyMeds: 'Acil Durum İlaçları',
            emergencyMedsPlaceholder: 'Acil durumda kullanılması gereken ilaçları listeleyin',
            section5: '5. Yasal Onay ve Rıza',
            kvkkConsent: 'KVKK (Kişisel Verilerin Korunması) Aydınlatma Metni\'ni okudum ve kabul ediyorum',
            guardianConsent: 'Öğrencinin yasal vasisi olduğumu veya öğrencinin bu konferansa katılmak için yasal vasi onayına sahip olduğunu onaylıyorum',
            submitApplication: 'Başvuruyu Gönder',
            submitting: 'Gönderiliyor...',
            successTitle: 'Başvuru Gönderildi!',
            successMessage: 'Girne MUN 2026\'ya başvurduğunuz için teşekkür ederiz. Başvurunuz alındı ve ekibimiz tarafından incelenecektir. Başvurunuzun durumu hakkında e-posta ile bilgilendirileceksiniz.',
            submitAnother: 'Başka Bir Başvuru Gönder',
            grades: {
                '9': '9. Sınıf',
                '10': '10. Sınıf',
                '11': '11. Sınıf',
                '12': '12. Sınıf',
                'graduate': 'Mezun'
            }
        },
        // Contact Page
        contact: {
            subtitle: 'İletişime Geçin',
            title: 'Bize Ulaşın',
            description: 'Girne MUN 2026 hakkında sorularınız mı var? Yardımcı olmak için buradayız. Ekibimize ulaşın, en kısa sürede size dönüş yapacağız.',
            emailUs: 'E-posta Gönderin',
            forGeneral: 'Genel sorular için',
            callUs: 'Bizi Arayın',
            visitUs: 'Bizi Ziyaret Edin',
            followUs: 'Bizi Takip Edin',
            stayUpdated: 'En son haberler ve duyurulardan haberdar olun.',
            sendMessage: 'Bize Mesaj Gönderin',
            formDesc: 'Aşağıdaki formu doldurun, 24-48 saat içinde yanıt vereceğiz.',
            yourName: 'Adınız',
            emailAddress: 'E-posta Adresi',
            subject: 'Konu',
            subjectPlaceholder: 'Sorunuz ne hakkında?',
            message: 'Mesaj',
            messagePlaceholder: 'Mesajınızı buraya yazın...',
            send: 'Mesaj Gönder',
            sending: 'Gönderiliyor...',
            successMessage: 'Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.',
            faq: 'Sık Sorulan Sorular',
            faqDesc: 'Aradığınızı bulamıyor musunuz? Hızlı cevaplar için SSS bölümümüze göz atın.',
            faqQuestions: {
                q1: 'Başvuru son tarihi nedir?',
                q2: 'Kayıt ücreti var mı?',
                q3: 'İlk kez delege olarak başvurabilir miyim?',
                q4: 'Konferansa ne getirmeliyim?'
            }
        },
        // Footer
        footer: {
            description: 'Lise öğrencileri arasında diplomasi, liderlik ve küresel farkındalık geliştiren birinci sınıf bir Model Birleşmiş Milletler konferansı.',
            quickLinks: 'Hızlı Bağlantılar',
            contactUs: 'Bize Ulaşın',
            email: 'E-posta',
            phone: 'Telefon',
            venue: 'Mekan',
            conference: 'Konferans',
            location: 'Konum',
            dates: 'Tarihler',
            applyNow: 'Hemen Başvur',
            allRights: 'Tüm hakları saklıdır.',
            privacyPolicy: 'Gizlilik Politikası',
            termsOfService: 'Kullanım Şartları',
            admin: 'Yönetici'
        },
        // Admin
        admin: {
            panel: 'Yönetim Paneli',
            managementSystem: 'Girne MUN 2026 Yönetim Sistemi',
            signIn: 'Hesabınıza giriş yapın',
            emailAddress: 'E-posta Adresi',
            password: 'Şifre',
            signingIn: 'Giriş yapılıyor...',
            demoCredentials: 'Demo Kimlik Bilgileri',
            backToSite: '← Ana siteye dön',
            dashboard: 'Gösterge Paneli',
            applications: 'Başvurular',
            signOut: 'Çıkış Yap',
            welcome: 'Tekrar hoş geldiniz! İşte Girne MUN 2026 başvurularına genel bakış.',
            totalApplications: 'Toplam Başvuru',
            pendingReview: 'İnceleme Bekleyen',
            accepted: 'Kabul Edilen',
            rejected: 'Reddedilen',
            recentApplications: 'Son Başvurular',
            viewAll: 'Tümünü gör',
            byGrade: 'Sınıfa Göre',
            needToReview: 'Başvuruları incelemeniz mi gerekiyor?',
            pendingWaiting: 'inceleme bekleyen başvurunuz var.',
            reviewNow: 'Şimdi İncele',
            manageApplications: 'Delege başvurularını yönetin ve inceleyin',
            searchPlaceholder: 'Ad, e-posta veya okul ara...',
            allStatus: 'Tüm Durumlar',
            pending: 'Beklemede',
            search: 'Ara',
            applicant: 'Başvuran',
            school: 'Okul',
            locationCol: 'Konum',
            status: 'Durum',
            submitted: 'Gönderildi',
            actions: 'İşlemler',
            noApplications: 'Başvuru bulunamadı',
            adjustFilters: 'Filtrelerinizi veya arama terimlerinizi ayarlamayı deneyin',
            applicationDetails: 'Başvuru Detayları',
            studentInfo: 'Öğrenci Bilgileri',
            fullName: 'Ad Soyad',
            dateOfBirth: 'Doğum Tarihi',
            schoolGrade: 'Okul & Sınıf',
            committeePrefs: 'Komite Tercihleri',
            parentInfo: 'Veli / Vasi Bilgileri',
            parentName: 'Veli Adı',
            parentPhone: 'Veli Telefonu',
            healthInfo: 'Sağlık Bilgileri',
            confidential: 'Gizli',
            chronicIllness: 'Kronik Hastalık',
            allergies: 'Alerjiler',
            emergencyMeds: 'Acil Durum İlaçları',
            accept: 'Kabul Et',
            reject: 'Reddet',
            setPending: 'Beklemeye Al',
            deleteApplication: 'Başvuruyu Sil',
            deleteConfirm: 'başvurusunu silmek istediğinizden emin misiniz? Bu işlem geri alınamaz.',
            cancel: 'İptal',
            delete: 'Sil'
        }
    },
    en: {
        // Navigation
        nav: {
            home: 'Home',
            about: 'About',
            committees: 'Committees',
            venue: 'Venue',
            contact: 'Contact',
            applyNow: 'Apply Now'
        },
        // Home Page
        home: {
            heroTitle1: 'Girne Model',
            heroTitle2: 'United Nations',
            tagline: "Shaping Tomorrow's Diplomats Today",
            learnMore: 'Learn More',
            countdown: {
                days: 'Days',
                hours: 'Hours',
                minutes: 'Minutes',
                seconds: 'Seconds'
            },
            features: {
                title: 'Excellence in Every Detail',
                subtitle: 'Why Choose Us',
                description: 'Girne MUN 2026 offers an unparalleled conference experience designed to inspire, educate, and empower the next generation of world leaders.',
                expertSecretariat: 'Expert Secretariat',
                expertSecretariatDesc: 'Experienced team dedicated to providing an exceptional MUN experience with professional guidance.',
                academicExcellence: 'Academic Excellence',
                academicExcellenceDesc: 'High-quality debates and discussions that challenge delegates to think critically and creatively.',
                globalPerspective: 'Global Perspective',
                globalPerspectiveDesc: 'Explore international issues and develop a deeper understanding of world affairs and diplomacy.',
                educationalGrowth: 'Educational Growth',
                educationalGrowthDesc: 'Develop essential skills in public speaking, negotiation, research, and leadership.'
            },
            stats: {
                committees: 'Committees',
                expectedDelegates: 'Expected Delegates',
                daysOfConference: 'Days of Conference',
                schoolsInvited: 'Schools Invited'
            },
            cta: {
                title: 'Ready to Make Your Mark?',
                description: 'Join hundreds of delegates from across Turkey in an unforgettable experience of diplomacy, debate, and discovery. Applications are now open.',
                viewCommittees: 'View Committees',
                applyNow: 'Apply Now',
                applicationNote: 'Applications close soon — Secure your spot at Girne MUN 2026'
            }
        },
        // About Page
        about: {
            subtitle: 'About The Conference',
            title: 'Girne Model United Nations',
            description: 'A premier academic simulation fostering diplomacy, leadership, and global awareness among high school students in Turkey.',
            whatIs: 'What is Girne MUN?',
            whatIsDesc1: 'Girne Model United Nations is an academic simulation of the United Nations that brings together high school students from across Turkey to discuss and debate pressing global issues. Our conference provides a platform for young minds to develop critical thinking, public speaking, and diplomatic skills.',
            whatIsDesc2: 'Founded with a vision to nurture future leaders, Girne MUN has grown to become one of the most respected Model UN conferences in the region. Our commitment to academic excellence and professional organization sets us apart, offering delegates an authentic and enriching experience.',
            whatIsDesc3: 'The 2026 edition promises to be our most ambitious conference yet, featuring 10 diverse committees covering topics ranging from international security to historical crises, all designed to challenge and inspire our delegates.',
            whatSetsUsApart: 'What Sets Us Apart',
            features: {
                trainedSecretariat: 'Professionally trained secretariat team',
                experiencedChairs: 'Experienced chairs and mentors',
                qualityGuides: 'High-quality study guides and resources',
                delegateTraining: 'Structured delegate training sessions',
                networking: 'Networking opportunities with peers',
                certificate: 'Certificate of participation for all delegates'
            },
            coreValues: 'Core Values',
            foundation: 'Our Foundation',
            excellence: 'Excellence',
            excellenceDesc: 'We strive for the highest standards in every aspect of our conference, from committee sessions to social events.',
            collaboration: 'Collaboration',
            collaborationDesc: 'We believe in the power of teamwork and encourage delegates to work together towards common goals.',
            integrity: 'Integrity',
            integrityDesc: 'We uphold ethical standards and promote honest, respectful discourse in all our proceedings.',
            leadership: 'Leadership',
            experiencedSecretariat: 'Experienced Secretariat',
            secretariatDesc1: 'Our secretariat team brings together some of the most experienced MUN organizers and former delegates from across Turkey. With years of combined experience in Model UN, our team is dedicated to creating an exceptional conference experience.',
            secretariatDesc2: 'From the Secretary-General to our committee chairs, every member of our team has been carefully selected for their expertise, dedication, and passion for Model United Nations. We are committed to supporting delegates at every step of their MUN journey.',
            daysOfConference: 'Days of Conference'
        },
        // Committees Page
        committees: {
            subtitle: 'Conference Committees',
            title: 'Our Committees',
            description: 'Explore our diverse selection of committees designed to challenge and inspire delegates at every experience level.',
            searchPlaceholder: 'Search committees...',
            committeesAvailable: 'committees available',
            keyTopics: 'Key Topics',
            noCommitteesFound: 'No committees found',
            adjustSearch: 'Try adjusting your search terms',
            notSure: 'Not Sure Which Committee?',
            notSureDesc: "When applying, you'll select your top three committee preferences. Our team will do their best to assign you to a committee that matches your interests and experience level.",
            beginner: 'Beginner: First-time delegates',
            intermediate: 'Intermediate: 1-3 conferences',
            advanced: 'Advanced: 4+ conferences',
            difficulty: {
                Beginner: 'Beginner',
                Intermediate: 'Intermediate',
                Advanced: 'Advanced'
            }
        },
        // Venue Page
        venue: {
            subtitle: 'Conference Venue',
            title: 'Girne College Campus',
            aboutVenue: 'About the Venue',
            aboutVenueDesc1: 'Girne MUN 2026 will be hosted at the prestigious Girne College Campus in Adana. Our venue provides state-of-the-art facilities perfect for hosting an academic conference of this caliber.',
            aboutVenueDesc2: 'The campus features modern conference rooms, spacious assembly halls, and comfortable breakout spaces designed to facilitate productive committee sessions and networking opportunities.',
            venueAmenities: 'Venue Amenities',
            amenities: {
                wifi: 'High-Speed WiFi',
                wifiDesc: 'Reliable internet throughout the venue',
                refreshments: 'Refreshments',
                refreshmentsDesc: 'Coffee breaks and catering provided',
                parking: 'Parking',
                parkingDesc: 'On-site parking available',
                capacity: 'Capacity',
                capacityDesc: 'Accommodates 300+ delegates'
            },
            clickToView: 'Click images to view full gallery',
            conferenceSchedule: 'Conference Schedule',
            threeDays: 'Three Days of Excellence',
            schedule: {
                day1: 'Day 1 - March 27',
                day2: 'Day 2 - March 28',
                day3: 'Day 3 - March 29',
                openingCeremony: 'Opening Ceremony',
                committeeSession1: 'Committee Session I',
                welcomeReception: 'Welcome Reception',
                committeeSession2: 'Committee Session II',
                committeeSession3: 'Committee Session III',
                socialEvent: 'Social Event',
                committeeSession4: 'Committee Session IV',
                closingCeremony: 'Closing Ceremony',
                awardsDistribution: 'Awards Distribution'
            },
            gettingThere: 'Getting There',
            address: 'Address',
            byCar: 'By Car',
            freeParking: 'Free parking available on campus',
            mapPlaceholder: 'Interactive map will be displayed here'
        },
        // Apply Page
        apply: {
            subtitle: 'Join Girne MUN 2026',
            title: 'Application Form',
            description: 'Complete the form below to apply as a delegate at our conference. Parent/guardian approval is required for all applications.',
            section1: '1. Student Information',
            firstName: 'First Name',
            lastName: 'Last Name',
            email: 'Email Address',
            phone: 'Phone Number',
            optional: 'optional',
            dateOfBirth: 'Date of Birth',
            grade: 'Grade / Class Level',
            selectGrade: 'Select grade',
            city: 'City',
            district: 'District',
            schoolName: 'School Name',
            section2: '2. Committee Preferences',
            committeeDesc: 'Select your top 3 committee preferences in order. Each committee can only be selected once.',
            preference1: '1st Committee Preference',
            preference2: '2nd Committee Preference',
            preference3: '3rd Committee Preference',
            selectFirst: 'Select your first choice',
            selectSecond: 'Select your second choice',
            selectThird: 'Select your third choice',
            section3: '3. Parent / Legal Guardian Information',
            parentName: 'Parent / Guardian Full Name',
            parentPhone: 'Parent / Guardian Phone Number',
            section4: '4. Health Information',
            healthConfidential: 'Confidential — This information is private and will only be accessible to conference organizers for emergency purposes.',
            chronicIllness: 'Does the student have a chronic illness?',
            yes: 'Yes',
            no: 'No',
            allergies: 'Allergies',
            ifAny: 'if any',
            allergiesPlaceholder: 'List any known allergies (food, medication, environmental, etc.)',
            emergencyMeds: 'Medications for Emergency Use',
            emergencyMedsPlaceholder: 'List any medications that must be used in case of an emergency',
            section5: '5. Legal & Consent',
            kvkkConsent: 'I have read and accept the KVKK (Personal Data Protection) Information Text',
            guardianConsent: 'I confirm that I am the legal guardian of the student or that the student has legal guardian approval to participate in this conference',
            submitApplication: 'Submit Application',
            submitting: 'Submitting...',
            successTitle: 'Application Submitted!',
            successMessage: 'Thank you for applying to Girne MUN 2026. Your application has been received and will be reviewed by our team. You will receive an email notification regarding the status of your application.',
            submitAnother: 'Submit Another Application',
            grades: {
                '9': 'Grade 9',
                '10': 'Grade 10',
                '11': 'Grade 11',
                '12': 'Grade 12',
                'graduate': 'Graduate'
            }
        },
        // Contact Page
        contact: {
            subtitle: 'Get in Touch',
            title: 'Contact Us',
            description: "Have questions about Girne MUN 2026? We're here to help. Reach out to our team and we'll get back to you as soon as possible.",
            emailUs: 'Email Us',
            forGeneral: 'For general inquiries',
            callUs: 'Call Us',
            visitUs: 'Visit Us',
            followUs: 'Follow Us',
            stayUpdated: 'Stay updated with the latest news and announcements.',
            sendMessage: 'Send us a Message',
            formDesc: "Fill out the form below and we'll respond within 24-48 hours.",
            yourName: 'Your Name',
            emailAddress: 'Email Address',
            subject: 'Subject',
            subjectPlaceholder: 'What is your inquiry about?',
            message: 'Message',
            messagePlaceholder: 'Type your message here...',
            send: 'Send Message',
            sending: 'Sending...',
            successMessage: "Your message has been sent successfully! We'll get back to you soon.",
            faq: 'Frequently Asked Questions',
            faqDesc: "Can't find what you're looking for? Check our FAQ section for quick answers.",
            faqQuestions: {
                q1: 'What is the application deadline?',
                q2: 'Is there a registration fee?',
                q3: 'Can I apply as a first-time delegate?',
                q4: 'What should I bring to the conference?'
            }
        },
        // Footer
        footer: {
            description: 'A premier Model United Nations conference fostering diplomacy, leadership, and global awareness among high school students.',
            quickLinks: 'Quick Links',
            contactUs: 'Contact Us',
            email: 'Email',
            phone: 'Phone',
            venue: 'Venue',
            conference: 'Conference',
            location: 'Location',
            dates: 'Dates',
            applyNow: 'Apply Now',
            allRights: 'All rights reserved.',
            privacyPolicy: 'Privacy Policy',
            termsOfService: 'Terms of Service',
            admin: 'Admin'
        },
        // Admin
        admin: {
            panel: 'Admin Panel',
            managementSystem: 'Girne MUN 2026 Management System',
            signIn: 'Sign in to your account',
            emailAddress: 'Email Address',
            password: 'Password',
            signingIn: 'Signing in...',
            demoCredentials: 'Demo Credentials',
            backToSite: '← Back to main site',
            dashboard: 'Dashboard',
            applications: 'Applications',
            signOut: 'Sign Out',
            welcome: "Welcome back! Here's an overview of Girne MUN 2026 applications.",
            totalApplications: 'Total Applications',
            pendingReview: 'Pending Review',
            accepted: 'Accepted',
            rejected: 'Rejected',
            recentApplications: 'Recent Applications',
            viewAll: 'View all',
            byGrade: 'By Grade',
            needToReview: 'Need to review applications?',
            pendingWaiting: 'pending applications waiting for review.',
            reviewNow: 'Review Now',
            manageApplications: 'Manage and review delegate applications',
            searchPlaceholder: 'Search by name, email, or school...',
            allStatus: 'All Status',
            pending: 'Pending',
            search: 'Search',
            applicant: 'Applicant',
            school: 'School',
            locationCol: 'Location',
            status: 'Status',
            submitted: 'Submitted',
            actions: 'Actions',
            noApplications: 'No applications found',
            adjustFilters: 'Try adjusting your filters or search terms',
            applicationDetails: 'Application Details',
            studentInfo: 'Student Information',
            fullName: 'Full Name',
            dateOfBirth: 'Date of Birth',
            schoolGrade: 'School & Grade',
            committeePrefs: 'Committee Preferences',
            parentInfo: 'Parent / Guardian Information',
            parentName: 'Parent Name',
            parentPhone: 'Parent Phone',
            healthInfo: 'Health Information',
            confidential: 'Confidential',
            chronicIllness: 'Chronic Illness',
            allergies: 'Allergies',
            emergencyMeds: 'Emergency Medications',
            accept: 'Accept',
            reject: 'Reject',
            setPending: 'Set Pending',
            deleteApplication: 'Delete Application',
            deleteConfirm: "'s application? This action cannot be undone.",
            cancel: 'Cancel',
            delete: 'Delete'
        }
    }
};

const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    const [language, setLanguage] = useState(() => {
        // Check localStorage for saved preference
        const saved = localStorage.getItem('language');
        return saved || 'tr'; // Default to Turkish
    });

    useEffect(() => {
        localStorage.setItem('language', language);
        document.documentElement.lang = language;
    }, [language]);

    const t = (key) => {
        const keys = key.split('.');
        let value = translations[language];
        
        for (const k of keys) {
            if (value && value[k] !== undefined) {
                value = value[k];
            } else {
                // Fallback to English if key not found
                value = translations['en'];
                for (const fallbackKey of keys) {
                    if (value && value[fallbackKey] !== undefined) {
                        value = value[fallbackKey];
                    } else {
                        return key; // Return key if not found
                    }
                }
                break;
            }
        }
        
        return value;
    };

    const toggleLanguage = () => {
        setLanguage(prev => prev === 'tr' ? 'en' : 'tr');
    };

    return (
        <LanguageContext.Provider value={{ language, setLanguage, toggleLanguage, t }}>
            {children}
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    const context = useContext(LanguageContext);
    if (!context) {
        throw new Error('useLanguage must be used within a LanguageProvider');
    }
    return context;
};

export default LanguageContext;
